import { render } from "./AppointmentBookingConfirmation.vue?vue&type=template&id=ac10eea4&scoped=true"
import script from "./AppointmentBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./AppointmentBookingConfirmation.vue?vue&type=script&lang=js"

import "./AppointmentBookingConfirmation.vue?vue&type=style&index=0&id=ac10eea4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac10eea4"]])

export default __exports__